import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CollectionService } from '@services/collection.service';
import { DomainFacade } from '@services/domain/domain.facade';
import { ValueDriverFacade } from '@services/value-driver/value-drivers.facade';
import { UserService } from './auth/user.service';
import { ToastModule } from '@airbus/components-angular';
import { ToasterService } from '@services/toaster.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private readonly userService = inject(UserService);
  private readonly collectionService = inject(CollectionService);
  private readonly domainFacade = inject(DomainFacade);
  private readonly valueDriverFacade = inject(ValueDriverFacade);
  toasterService = inject(ToasterService);

  closeToaster() {
    const toasterElement = document.getElementsByTagName('ds-toast').item(0) as HTMLElement;
    if (toasterElement) {
      toasterElement.classList.add('leave');
    }
    setTimeout(() => this.toasterService.close(), 500);
  }

  ngOnInit(): void {
    this.userService.user$.subscribe((user) => {
      if (!user) {
        console.error('user not connected');
        return;
      }

      this.domainFacade.setDomains();
      this.valueDriverFacade.setValueDrivers();
      if (!user.isAnonymous()) {
        this.collectionService.initCollections();
      }
    });
  }
}
